import {Component, OnInit} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { environment } from '../environments/environment';

registerLocaleData(localePt);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  showBanner = !environment.production;

  ngOnInit(): void {
    if (this.showBanner) {
      document.body.classList.add('is-homol');
    }
  }
}
